var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('user-info-base',{staticClass:"p-user-info--pc",attrs:{"carat":_vm.carat},on:{"open-about-mycolor":function($event){return _vm.$emit('open-about-mycolor')}}})}
var staticRenderFns = []

export { render, staticRenderFns }